import { logout } from 'actions/user';
import BlobImage from 'components/blobImage';
import EditImage from 'components/header/components/editImage';
import LanguageSelector from 'components/user/languageSelector';
import { SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const Signout = ({ history }) => {
    const dispatch = useDispatch();

    const [showImageEdit, setShowImageEdit] = React.useState(false);

    const user = useSelector(state => state.user.user);
    const jobTitle = user.job_Title ? ` - ${user.job_Title}` : '';

    const signout = () => {
        if (user.authority === 'azure') {
            dispatch(logout(null, 'azure', msalLogout));
        } else {
            dispatch(logout(history, user.authority));
        }
    };

    return (
        <>
            <li className="user-header">
                <div
                    className="user-header-image-wrapper pointer"
                    style={{ position: 'relative' }}
                    title={SystemText('Header/ImageEdit')}
                    onClick={() => setShowImageEdit(true)}
                >
                    <div>
                        <i className="fa fa-pencil" />
                    </div>
                    <BlobImage
                        width="90"
                        height="90"
                        folder="avatar"
                        initials={user.initials}
                        key={user.avatar}
                        src={user.avatar}
                        className="img-circle"
                    />
                </div>
                <p>{user && `${user.full_Name}${jobTitle}`}</p>
                <LanguageSelector />
            </li>
            <li className="user-footer">
                <div className="text-center">
                    <button
                        tabIndex="30"
                        data-testid="button-header-user-logoff"
                        className="btn btn-primary btn-block"
                        onClick={() => signout()}
                    >
                        {SystemText('Header/Buttons/SignOut')}
                    </button>
                </div>
            </li>
            <div className="text-black">
                <EditImage show={showImageEdit} onClose={() => setShowImageEdit(false)} />
            </div>
        </>
    );
};

export default Signout;
